import AggregateConfig from "../configurations/QueryBuilder/AggregateConfig.json";

const aggregateFunctionHash = AggregateConfig.aggregateFunction;

/**
 * Takes `obj` as input replaces value which matches with the `value`
 * with `replaceValue`. Recursive in nature
 * @param {Object} obj
 * @param {String} value
 * @param {String} replaceValue
 */
const deepUpdate = (obj, value, replaceValue) => {
	for (let i in obj) {
		if (obj[i] === value) {
			obj[i] = replaceValue;
			return obj;
		} else if (obj[i] instanceof Object) {
			obj[i] = deepUpdate(obj[i], value, replaceValue);
			return obj;
		}
	}
	console.log("Couldn't find value in object");
	return obj;
};

/**
 * Takes single aggregation block and returns the mongodb partial for it
 *
 * Input:
 * {
 *      aggregate: "sum",
 *      keyword: "cost_beneficiary",
 *      newField: "cost_beneficiary_sum"
 * }
 *
 * Output:
 * {
 *      cost_beneficiary_sum: {
 *          $sum: "cost_beneficiary"
 *      }
 * }
 *
 * @param {Object} aggregationBlock
 */
const aggregateFunctionUtility = ({ aggregate, keyword, newField }) => {
	const aggregateFunction = {
		...aggregateFunctionHash[aggregate].conversion
	};
	const result = {};
	result[newField] =
		aggregate !== "custom" ? deepUpdate(aggregateFunction, "$$keyword", `$${keyword}`) : keyword;
	return result;
};

export default aggregateFunctionUtility;
